import * as React from "react";
function SvgCandles(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M7 15h6v16H7zM8.33 11H12l2-3-4-7-4 7 2.33 3zM19 19h6v12h-6zM20.33 15H24l2-3-4-5-4 5 2.33 3z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCandles);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
